function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ED0B5D03-B4C2-4A4B-8290-E3AB6126FC75");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admissions",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd",
  fill: "#2F4858"
}, /*#__PURE__*/React.createElement("g", {
  id: "mixedAdmissionsLoginExisting",
  transform: "translate(-786.000000, -443.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "accountOptionsModal",
  transform: "translate(530.000000, 206.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "groupPromoHeader",
  transform: "translate(234.000000, 164.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Clock",
  transform: "translate(22.000000, 73.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.32704406,5.8451749 L7.41527935,5.8451749 L7.41527935,3.98803205 C7.41527935,3.64614149 7.12997061,3.36898443 6.77802445,3.36898443 C6.42607829,3.36898443 6.14076955,3.64614149 6.14076955,3.98803205 L6.14076955,6.46422252 C6.14076955,6.80611308 6.42607829,7.08327014 6.77802445,7.08327014 L9.32704406,7.08327014 C9.67899022,7.08327014 9.96429896,6.80611308 9.96429896,6.46422252 C9.96429896,6.12233196 9.67899022,5.8451749 9.32704406,5.8451749 Z M6.5,0.371428571 C3.12131682,0.371428571 0.382352941,3.11528346 0.382352941,6.5 C0.382352941,9.88471654 3.12131682,12.6285714 6.5,12.6285714 C9.87868318,12.6285714 12.6176471,9.88471654 12.6176471,6.5 C12.6176471,4.8746018 11.9731111,3.31577567 10.8258297,2.16644558 C9.67854835,1.01711549 8.12250088,0.371428571 6.5,0.371428571 Z M6.5,11.5142857 C3.75481992,11.5142857 1.52941176,9.26931353 1.52941176,6.5 C1.52941176,3.73068647 3.75481992,1.48571429 6.5,1.48571429 C9.24518008,1.48571429 11.4705882,3.73068647 11.4705882,6.5 C11.4705882,7.82987126 10.9469028,9.10527445 10.0147366,10.0456354 C9.08257053,10.9859964 7.81828196,11.5142857 6.5,11.5142857 Z",
  id: "iconClock",
  transform: "translate(6.500000, 6.500000) rotate(-1.000000) translate(-6.500000, -6.500000) "
}))))));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.d5207151.svg";
export { ForwardRef as ReactComponent };